import React from 'react'

import { CommonLogoWithBack, CommonLogoWithBackProps } from '../CommonLogoWithBack'
import BrandedAppLogo from '../icons/WixBrandedLogo.svg'

type BrandedAppWithBackProps = Omit<CommonLogoWithBackProps, 'logo'> & { logoColor?: string }

export const BrandedAppLogoWithBack = (props: BrandedAppWithBackProps) => {
  return <CommonLogoWithBack {...props} logo={<BrandedAppLogo height={27} width={167} fill={props.logoColor} />} />
}
